import { render } from "./about.vue?vue&type=template&id=2af57e98&scoped=true"
const script = {}

import "./about.vue?vue&type=style&index=0&id=2af57e98&scoped=true&lang=css"

import exportComponent from "/Users/hansteve/Desktop/work/qingshui/qingshui_home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af57e98"]])

export default __exports__